module.exports = __webpack_public_path__ + "img/xzIco (7).7273a44a.png";